/* eslint-disable import/prefer-default-export */
export const GET_COVERAGES_FOR_PRODUCT = 'coverage/GET_COVERAGES_FOR_PRODUCT';
